<template>
  <div class="seat-map">
    <div class="seat-row seat-row-head">
      <div class="seat-title" v-for="(col, index) in seatRowData[0]" :key="index">
        <span v-if="col.col!='=' && col.seatStatus!='E'">{{col.col}}</span>
        <span v-else-if="col.col=='='" class="space"></span>
      </div>
    </div>
    <div class="seat-row" v-for="(row, rowIndex) in seatRowData" :key="rowIndex">
      <seat-col :seatRow="row" @selectSeat="selectSeat"></seat-col>
    </div>
  </div>
</template>
<script>
import seatCol from './seatCol'
export default {
  props: {
    seatData: Array
  },
  watch: {
    seatData: {
      handler: function (val, oldVal) {
        if (val) {
          this.seatDataFilter(val)
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      seatRowData: []
    }
  },
  methods: {
    seatDataFilter () {
      const { seatData } = this
      this.seatRowData = []
      let row = []
      for (let index = 0; index < seatData.length; index++) {
        const seat = seatData[index]
        if (index === 0) {
          row.push(seat)
        } else if (index > 0 && seat.row === seatData[index - 1].row) {
          row.push(seat)
          if (index === seatData.length - 1) {
            this.seatRowData.push(row)
          }
        } else {
          this.seatRowData.push(row)
          row = []
          row.push(seat)
        }
      }
    },
    selectSeat (seatNum) {
      this.$emit('selectSeat', seatNum)
    }
  },
  components: {
    seatCol
  }
}
</script>
<style lang="less">
.seat-map {
    position: relative;
    min-width: 500px;
    height: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    display: flex;
  .seat-row {
    width: 20px;
    height: 100%;
    margin: 0 3px;
    display: inline-block;
    white-space: nowrap;
    vertical-align: top;
    .seat-title {
      span {
        display: block;
        width: 18px;
        height: 18px;
        margin: 3px 0;
      }
    }
  }
  .seat-row-head {
    display: flex;
    flex-direction: column-reverse;
    .seat {
      background: none;
    }
  }
}
@media only screen and (max-width: 768px) {
  .airplane-type-330 {
    .seat-map {
      .seat-row {
        .seat-title span {
          width: 23px;
          height: 23px;
        }
      }
    }
  }
  .seat-map {
    .seat-row {
      float: none;
      width: 100%;
      height: auto;
      .seat-title {
        float: left;
        text-align: center;
        span {
          width: 30px;
          height: 30px;
          margin: 3px;
        }
      }
      .seat-col {
        display: inline-block;
        vertical-align: middle;
      }
    }
    .seat-row {
      zoom: 1;
    }
    .seat-row:before,
    .seat-row:after {
      content: "";
      display: table;
    }
    .seat-row:after {
      clear: both;
    }
  }
}
</style>
